document.addEventListener('DOMContentLoaded', function () {
    const specificationBlocks = document.querySelectorAll('.block-half-text-specification__spec-panel');

    if (specificationBlocks.length === 0) return;

    specificationBlocks.forEach(function (panel) {
        const showMoreButton = panel.querySelector('.block-half-text-specification__show-more');

        if (!showMoreButton) return;

        showMoreButton.addEventListener('click', function () {
            const isExpanded = panel.classList.toggle('is-expanded');
            const label = isExpanded
                ? showMoreButton.dataset.showLessLabel || 'Show less -'
                : showMoreButton.dataset.showMoreLabel || 'Show more +';

            showMoreButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
            showMoreButton.textContent = label;
        });
    });
});
